import { StyleSheet } from '@react-pdf/renderer'

export const styles = StyleSheet.create({
  box: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.04)',
    gap: 8,
    padding: '24px',
  },
  dot: {
    backgroundColor: '#f00',
    borderRadius: '50%',
    height: '8px',
    width: '8px',
  },
  noData: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: 'normal',
    textAlign: 'center',
  },
  text: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: 'normal',
  },
  textContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: 12,
  },
  title: {
    fontFamily: 'Montserrat',
    fontSize: 18,
    fontWeight: 'semibold',
    marginBottom: '18px',
  },
})
